import React from "react";

const ExperienceModule = ({ payload }) => {
	return <>{payload[1].gray_text}</>;
};

export default ExperienceModule;
